module.exports = __webpack_public_path__ + "cbe3438458dc9911aafd202ea7a2fac0.otf";